module.exports = __webpack_public_path__ + "static/media/Icon LinkedIn.88d80393.svg";